import { Menu } from "@mui/icons-material";
import { Badge, Tooltip } from "@mui/material";
import { useEffect, useMemo } from "react";
import { isInsideIframe } from "../../../../../utils/iframe";
import { ChatIcon, ChatToggleButton, StyledChatToggleButtonContainer } from "../../../../styled/ZoomContainer";


const ChatToggleButtonContainer = ({ toggleChat, isChatOpen, unreadMessages = 0, tieneViewportPocaAltura }) => {


  const disableChat = useMemo(() => {
    return isInsideIframe() && tieneViewportPocaAltura;
  }, [tieneViewportPocaAltura]);

  const tooltip = useMemo(() => {
    if (disableChat) {
      return "Para utilizar el chat en esta videollamada, maximice el tamaño de la ventana";
    }
    return isChatOpen ? "Cerrar chat" : "Abrir chat";
  }, [isChatOpen, disableChat])

  useEffect(() => {
    if (disableChat && isChatOpen) {
      toggleChat();
    }
  }, [disableChat, isChatOpen, toggleChat]);

  if (isChatOpen) {
    return null;
  }
  return (

    <Tooltip title={tooltip} arrow>
      <StyledChatToggleButtonContainer>
        <Badge
          badgeContent={unreadMessages}
          color="error"
          max={99}
          invisible={unreadMessages === 0}
          overlap="rectangular"
          anchorOrigin={{ vertical: "top", horizontal: "left" }}
          sx={{
            "& .MuiBadge-badge": {
              top: 4,
              left: 4,
              fontSize: 11,
              fontWeight: 600,
              minWidth: 18,
              height: 18,
              padding: "0 5px",
            },
          }}
        >
          <ChatToggleButton
            color="white"
            id="chatToggleButton"
            onClick={toggleChat}
            disabled={disableChat}
          >
            {isChatOpen ? <ChatIcon /> : <Menu />}
          </ChatToggleButton>
        </Badge>
      </StyledChatToggleButtonContainer>


    </Tooltip>
  )
}

export default ChatToggleButtonContainer;